module.exports = __webpack_public_path__ + "static/media/ic_hashtag.6f9434a4.svg";